import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

/**
 * IcBrokerSolidComponent for rendering solid broker icon with optional gradient.
 */
@Component({
  selector: 'ic-broker-solid',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './ic-broker-solid.html',
})
export class IcBrokerSolidComponent {
  /** The starting color of the icon gradient. */
  @Input() startColor: string | null = null;

  /** The ending color of the icon gradient. */
  @Input() endColor: string | null = null;

  /** The opacity of the icon. Defaults to 1. */
  @Input() opacity = 1;

  /** The width of the icon. Defaults to 20. */
  @Input() width: number | string = 20;

  /** The height of the icon. Defaults to 12. */
  @Input() height: number | string = 12;

  /** Solid color for the icon. */
  @Input() color = 'currentColor';

  /** Default color when no color or gradient is provided. */
  defaultColor = '#B8C0C6';

  /** Unique ID for the SVG gradient. */
  gradientId = `brokerSolidGradient-${Math.random().toString(36).slice(2)}`;

  /** Checks if gradient is provided. */
  get hasGradient(): boolean {
    return !!(this.startColor && this.endColor);
  }
}
